export default __webpack_public_path__ + "static/media/ic-general-settings.f9df3bb6.svg";